import { motion } from 'framer-motion';
import useParticipantsWithHost from '../../hooks/useParticipantsWithHost';
import useSuggestionStateManager from '../../hooks/useSuggestionStateManager';
import { TURN_PHASES } from '../../hooks/useWSTurnState';
import SuggestionMessage from './SuggestionMessage';
import './SuggestionsPanel.css';

export default function SuggestionsPanel({ currentPhase }) {
  const { activeSuggestions } = useSuggestionStateManager();
  const { whoAmI } = useParticipantsWithHost();

  const shouldDisplayForA = currentPhase === TURN_PHASES.SelfIntroductionsA && whoAmI === 'A';
  const shouldDisplayForB = currentPhase === TURN_PHASES.SelfIntroductionsB && whoAmI === 'B';
  const shouldShow = (shouldDisplayForA || shouldDisplayForB) && activeSuggestions.length > 0;

  return (
    <motion.div
      style={{
        transformOrigin: 'bottom',
      }}
      key={`suggestions-${currentPhase}`}
      className="suggestions-panel"
      initial={{ y: '100%' }}
      animate={{
        y: shouldShow ? '0%' : '100%',
        pointerEvents: shouldShow ? 'auto' : 'none',
      }}
      transition={{ duration: 0.3, ease: 'easeIn' }}
    >
      <motion.div
        style={{ transformOrigin: 'bottom' }}
        className="suggestions-messages"
      >
        {activeSuggestions
          .slice()
          .reverse()
          .map((suggestion, index) => (
            <SuggestionMessage
              key={suggestion.id}
              text={suggestion.text}
              index={index}
            />
          ))}
      </motion.div>
      <div className="suggestions-header">You could say…</div>
    </motion.div>
  );
}

